import LogService from '../../services/log-service';
import { AlternateLocaleMap, Development, English, ShipStationSupportedLocales } from './locale-codes';

const getNormalizedLocale = (locale) => {
  if (locale === Development) {
    return locale;
  }

  try {
    const canonicalLocales = Intl.getCanonicalLocales(locale);
    return canonicalLocales[0] ?? English;
  } catch (err) {
    LogService.logWarning('Cannot get cannonical locale', {
      locale,
      err,
    });
    return English;
  }
};

const getAlternateLocale = (locale) => {
  return AlternateLocaleMap[locale];
};

const getBaseLocale = (locale) => {
  if (!locale) {
    return null;
  }
  return locale.slice(0, locale.indexOf('-'));
};

const getSupportedLocale = (availableLocales, locale) => {
  const normalizedLocale = getNormalizedLocale(locale);
  if (availableLocales?.includes(normalizedLocale)) {
    return normalizedLocale;
  }

  const alternateLocale = getAlternateLocale(normalizedLocale);
  if (availableLocales?.includes(alternateLocale)) {
    return alternateLocale;
  }

  const baseLocale = getBaseLocale(normalizedLocale);
  if (availableLocales?.includes(baseLocale)) {
    return baseLocale;
  }

  return null;
};

const getShipStationSupportedLocale = (locale) => {
  return getSupportedLocale(ShipStationSupportedLocales, locale);
};

export { getSupportedLocale, getShipStationSupportedLocale };
